import { useScroll, useSpring, motion } from 'framer-motion';
import { Outlet } from 'react-router-dom';
import InitiativeHeader from './InitiativeHeader';
import InitiativeFooter from './InitiativeFooter';

const InitiativeLayout = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <InitiativeHeader />
      <motion.div
        className="fixed top-0 left-0 right-0 h-0.5 bg-[#FFA92C] z-[60] origin-left"
        style={{ scaleX }}
      />
      <main className="flex-1 pt-24 lg:pt-26">
        <Outlet />
      </main>
      <InitiativeFooter />
    </div>
  );
};

export default InitiativeLayout;
